import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Tool extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M14.1,9c-0.2-0.2-0.4-0.2-0.7-0.2l-2.1,0.6L9.3,7.4L8.6,6.7L6.6,4.6l0.6-2.1c0.1-0.2,0-0.5-0.2-0.7L5.1,0
          l-1,1l1.6,1.6L5,5L2.6,5.7L1,4.1l-1,1L1.9,7C2,7.1,2.2,7.2,2.4,7.2c0.1,0,0.1,0,0.2,0l2.1-0.6l2.1,2.1l0.6,0.6l2.1,2.1l-0.6,2.1
          c-0.1,0.2,0,0.5,0.2,0.7l1.9,1.9l1-1l-1.6-1.6L11,11l2.5-0.7l1.6,1.6l1-1L14.1,9z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Tool.js